import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
  createIntegrationForOrganizationService,
  getIntegrationService,
  getOrganizationIntegrationService
} from 'services/integrationService';
import { AuthContext } from 'context/Context';
import IconButton from 'components/common/IconButton';
import IntegrationWrapper from './IntegrationWrapper';
import IntegrationFormatForm from './IntegrationFormatForm';
import useError from 'hooks/useError';

const index = () => {
  const { orgId } = useContext(AuthContext);
  const { getResponse } = useError();

  const [integrations, setIntegrations] = useState([]);
  const [integrationsOptions, setIntegrationOptions] = useState([]);
  const [orgPreventionIntegrations, setOrgPreventionIntegrations] = useState(
    []
  );
  const [orgDetectionIntegrations, setOrgDetectionIntegrations] = useState([]);
  const [preventionformData, setPreventionFormData] = useState({
    name: null
  });
  const [detectionformData, setDetectionFormData] = useState({
    name: null
  });

  const getIntegrations = async () => {
    const res = await getIntegrationService();
    getResponse(res)
      .then(res => {
        setIntegrations(res?.data);
        setIntegrationOptions(
          res?.data?.map(int => ({ value: int.slug, label: int.name }))
        );
      })
      .catch(err => console.error(err));
  };

  const getOrgIntegrations = async () => {
    const res = await getOrganizationIntegrationService(orgId);
    getResponse(res)
      .then(res => {
        setOrgDetectionIntegrations(res.filter(i => i.type === 'detected'));
        setOrgPreventionIntegrations(res.filter(i => i.type === 'prevented'));
      })
      .catch(err => console.error(err));
  };

  useEffect(() => {
    getIntegrations();
    getOrgIntegrations();
  }, []);

  const handlePreventionChange = e => {
    const { id, value } = e.target;
    setPreventionFormData({ ...preventionformData, [id]: value });
  };

  const handleDetectionChange = e => {
    const { id, value } = e.target;
    setDetectionFormData({ ...detectionformData, [id]: value });
  };

  const getFields = name => {
    let empty = [];
    const integration = integrations.find(i => i.slug === name);
    integration?.secrets?.forEach(s => {
      empty.push({ id: s.key, label: s.label });
    });
    return empty;
  };

  const createOrgIntegration = async data => {
    const res = await createIntegrationForOrganizationService(
      orgId,
      data.integrationId,
      data
    );
    getResponse(res)
      .then(res => {
        getOrgIntegrations();
        toast(<span className="text-success">{res.message}</span>);
      })
      .catch(err => console.error(err));
  };

  const handleAddDetection = () => {
    const secrets = getFields(detectionformData.name);
    let { name, ...rest } = detectionformData;
    if (secrets.length !== Object.keys(rest).length) {
      toast(
        <span className="text-danger">Please fill the required fields.</span>
      );
      return;
    }
    const integration = integrations.find(
      i => i.slug === detectionformData.name
    );
    const data = {
      integrationId: integration.id,
      name: detectionformData.name,
      type: 'detected',
      secrets: {
        ...rest
      }
    };
    createOrgIntegration(data);
  };
  const handleAddPrevention = () => {
    const secrets = getFields(preventionformData.name);
    let { name, ...rest } = preventionformData;
    if (secrets.length !== Object.keys(rest).length) {
      toast(
        <span className="text-danger">Please fill the required fields.</span>
      );
      return;
    }
    const integration = integrations.find(
      i => i.slug === preventionformData.name
    );
    const data = {
      integrationId: integration.id,
      name: preventionformData.name,
      type: 'prevented',
      secrets: {
        ...rest
      }
    };
    createOrgIntegration(data);
  };

  return (
    <div className="m-3">
      <h4>Integrations</h4>
      <div className="row m-0 mt-3">
        <div className="col-md-5 m-0 p-0">
          <div class="d-flex justify-content-between">
            <h6>Prevention</h6>
            {orgPreventionIntegrations?.length > 0 && (
              <h6 classNamee="md-auto">
                ({orgPreventionIntegrations?.length})
              </h6>
            )}
          </div>
          <IntegrationFormatForm
            title={'Prevention'}
            integrationOptions={integrationsOptions}
            data={preventionformData}
            handleChange={handlePreventionChange}
            fields={getFields(preventionformData.name)}
          />
          <IconButton
            variant="outline-primary"
            className="mb-1 mt-2"
            icon="plus"
            transform="shrink-3"
            onClick={handleAddPrevention}
          >
            Add
          </IconButton>
          {orgPreventionIntegrations?.map(integration => (
            <IntegrationWrapper data={integration} type={'Prevention'} />
          ))}
        </div>
        <div className="col-md-5">
          <div class="d-flex justify-content-between">
            <h6>Detection</h6>
            {orgDetectionIntegrations?.length > 0 && (
              <h6 classNamee="ml-auto">({orgDetectionIntegrations?.length})</h6>
            )}
          </div>
          <IntegrationFormatForm
            title={'Detection'}
            integrationOptions={integrationsOptions}
            data={detectionformData}
            handleChange={handleDetectionChange}
            fields={getFields(detectionformData.name)}
          />
          <IconButton
            variant="outline-primary"
            className="mb-1 mt-2"
            icon="plus"
            transform="shrink-3"
            onClick={handleAddDetection}
          >
            Add
          </IconButton>
          {orgDetectionIntegrations?.map(integration => (
            <IntegrationWrapper data={integration} type={'Detection'} />
          ))}
        </div>
      </div>

      <div className="card mt-3">
        <div className="card-body">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-file-arrow-up"
            viewBox="0 0 16 16"
          >
            <path d="M8 11a.5.5 0 0 0 .5-.5V6.707l1.146 1.147a.5.5 0 0 0 .708-.708l-2-2a.5.5 0 0 0-.708 0l-2 2a.5.5 0 1 0 .708.708L7.5 6.707V10.5a.5.5 0 0 0 .5.5z"></path>
            <path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"></path>
          </svg>{' '}
          Upcoming integrations:
          <ul style={{ listStyle: 'none' }}>
            <li className="mt-3">
              <img
                style={{ height: '32px', width: 'auto', marginRight: '2rem' }}
                src="data:image/png;base64,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"
              />
            </li>
            <li className="mt-3">
              <img
                style={{ height: '32px', width: 'auto', marginRight: '2rem' }}
                src="https://imgix.datadoghq.com/img/dd_logo_n_70x75.png?ch=Width,DPR&fit=max&auto=format&w=70&h=75"
                alt=""
                srcset=""
              />
              <b className={{ fontSize: '24px' }}>DataDog</b>
            </li>
            <li className="mt-3">
              <img
                style={{ height: '18px', width: 'auto', marginRight: '2rem' }}
                src="https://www.logpoint.com/wp-content/uploads/2022/12/logpoint-logo-200x24.png"
                alt=""
                srcset=""
              />
            </li>
            <li className="mt-3">
              <img
                style={{ height: '75px', width: 'auto', marginRight: '2rem' }}
                src="https://www.vectorlogo.zone/logos/solarwinds/solarwinds-ar21.svg"
                alt=""
                srcset=""
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default index;
